export default __webpack_public_path__ + "static/media/arrow.11179a76.svg";